import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';


import { Globals } from 'app/_models/globals';
import { SupportFinancialDashboardService } from './financial-dashboard.service';
import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { SupportFinancialDashboardDataComponent } from './_components/financial-dashboard-data/financial-dashboard-data.component';
import { FinancialDashboardData } from './_models/financialDashboardData';
import { PlanEnum } from 'app/_models/plans';
import { GetFinancialDashboardTotalResponseModel } from './_models/getFinancialDashboardTotalResponseModel';
import { createDefaultFinancialDashboardActualMonth, FinancialDashboardTotalMonthData } from './_models/financialDashboardTotalMonthModel';
import { GetFinancialDashboardByDayResponseModel } from './_models/getFinancialDashboardByDayResponseModel';
import { GetFinancialDashboardCommerceResponseModel } from './_models/getFinancialDashboardCommerceResponseModel';
import { GetFinancialDashboardCashbackResponseModel } from './_models/getFinancialDashboardCashbackResponseModel';
import { FilterOption } from 'app/_componentes/header/_models/filterOption';
import { formatDateToMonthTextAndYear } from 'app/_utils/general-utils';

@Component({
    selector: 'app-financial-dashboard', templateUrl: './financial-dashboard.component.html', styleUrls: ['./financial-dashboard.component.scss'],
    standalone: false
})
export class SupportFinancialDashboardComponent implements OnInit, AfterViewInit {
    @ViewChild('transactedValueUntilTodaySection') transactedValueUntilTodaySection: SupportFinancialDashboardDataComponent;
    @ViewChild('transactedValueByWorkingDaySection') transactedValueByWorkingDaySection: SupportFinancialDashboardDataComponent;
    @ViewChild('transactedValueTotalSection') transactedValueTotalSection: SupportFinancialDashboardDataComponent;
    @ViewChild('transactedValueByDaySection') transactedValueByDaySection: SupportFinancialDashboardDataComponent;
    @ViewChild('transactedCommerceValueSection') transactedCommerceValueSection: SupportFinancialDashboardDataComponent;
    @ViewChild('transactedCommerceValueGraphSection') transactedCommerceValueGraphSection: SupportFinancialDashboardDataComponent;
    @ViewChild('transactedCashbackValueSection') transactedCashbackValueSection: SupportFinancialDashboardDataComponent;

    private getFinancialDashboardCashbackResponseData: GetFinancialDashboardCashbackResponseModel[];
    private getFinancialDashboardCommerceResponseData: GetFinancialDashboardCommerceResponseModel[];
    private getFinancialDashboardTotalResponseData: GetFinancialDashboardTotalResponseModel[];
    private getFinancialDashboardByDayResponseData: GetFinancialDashboardByDayResponseModel[];

    public transactedValueByDay: FinancialDashboardData;
    public transactedValueByWorkingDayData: FinancialDashboardData;
    public transactedCashbackValueData: FinancialDashboardData;
    public transactedCommerceValueData: FinancialDashboardData;
    public transactedValueUntilTodayData: FinancialDashboardData;
    public transactedValueTotalData: FinancialDashboardData;

    public selectedPlans: PlanEnum[] = [PlanEnum.Popular, PlanEnum.V8, PlanEnum.Turbo];
    public selectCashbackOptions: FilterOption[] = []
    public selectCashbackCustom = true;
    public selectCashbackRebate = true;
    public actualDay: number;
    public actualMonth: number;
    public actualYear: number;
    public lastMonths: Date[] = [];
    public lastMonthsLabel: string[] = [];
    private lastMonthsCount = 12;
    private _selectedCashbackFilter: string = '0';
    private _selectedMonthIndexFilter: string = '0';
    private _selectedPlanFilter: string = '0';
    private selectedMonth: number = 0;
    private selectedYear: number = 0;

    constructor(
        private financialDashboardService: SupportFinancialDashboardService,
        private globals: Globals) { }

    ngOnInit(): void {
        var today = new Date();
        this.actualDay = today.getDate();
        this.actualMonth = today.getMonth() + 1;
        this.actualYear = today.getFullYear();

        this.lastMonths = Array.from({ length: this.lastMonthsCount }, (_, i) => {
            const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
            return d;
        });

        this.lastMonthsLabel = this.lastMonths.map((date) => {
            return formatDateToMonthTextAndYear(date);
        })

        this.updateSelectedMonthAndYear();

        this.selectCashbackOptions = [
            { value: '0', label: this.globals.translate('support.dashboard.dashboard-data.cashback-filter.all') },
            { value: '1', label: this.globals.translate('support.dashboard.dashboard-data.cashback-filter.custom') },
            { value: '2', label: this.globals.translate('support.dashboard.dashboard-data.cashback-filter.rebate') }
        ];
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.getTransactedValueTableData();
            this.getTransactedValueByDayData();
            this.getTransactedCommerceValueTableData();
            this.getTransactedCashbackValueTableData();
        }, 0);
    }

    buildTableData(actualMonthData: FinancialDashboardTotalMonthData, months: FinancialDashboardTotalMonthData[], valueKey: string, isCurrency: boolean, label: string, mustReverse: boolean = true, totalWorkingDaysKey: string = 'totalWorkingDaysUntilSelectedDate') {
        var response = {
            actualMonthValue: actualMonthData[valueKey],
            isCurrency,
            label: this.globals.translate(`support.dashboard.dashboard-data.table.title.${label}`),
            months: months.map(month => {
                const percentageDifferenceFromActualMonth = this.handleDivisionTreatingZeroDivisionError((actualMonthData[valueKey] - month[valueKey]), month[valueKey]) * 100;

                return {
                    formattedDate: formatDateToMonthTextAndYear(new Date(month.year, month.month - 1, 1)),
                    value: month[valueKey],
                    workingDaysQuantity: month[totalWorkingDaysKey],
                    isBetherThanActualMonth: percentageDifferenceFromActualMonth < 0,
                    percentageDifferenceFromActualMonth: Math.abs(percentageDifferenceFromActualMonth),
                    isBestMonth: month.isBestMonth,
                    isActualMonth: month.isActualMonth,
                    isLastYearMonth: month.isLastYearMonth
                }
            })
        }

        if (mustReverse)
            response.months = response.months.reverse();

        return response;
    };

    public getTransactedCashbackValueTableData() {
        this.transactedCashbackValueSection.startLoader();

        this.financialDashboardService.getTransactedCashbackValueData(this.selectedMonth, this.selectedYear).subscribe({
            next: (res: ApiResponseModel<GetFinancialDashboardCashbackResponseModel[]>) => {
                this.getFinancialDashboardCashbackResponseData = res.result.reverse();

                this.filterDataCashbackGraph(res.result);
                this.transactedCashbackValueSection.completeLoad(this.transactedCashbackValueData);
            },
            error: () => {
                this.transactedCashbackValueSection.completeLoad(null);
            }
        });
    }

    public getTransactedCommerceValueTableData() {
        this.transactedCommerceValueSection.startLoader();
        this.transactedCommerceValueGraphSection.startLoader();

        this.financialDashboardService.getTransactedCommerceValueData(this.selectedMonth, this.selectedYear).subscribe({
            next: (res: ApiResponseModel<GetFinancialDashboardCommerceResponseModel[]>) => {
                this.getFinancialDashboardCommerceResponseData = res.result.reverse();

                this.filterDataCommerceGraph(res.result);
                this.transactedCommerceValueSection.completeLoad(this.transactedCommerceValueData);
                this.transactedCommerceValueGraphSection.completeLoad(this.transactedCommerceValueData);
            },
            error: () => {
                this.transactedCommerceValueSection.completeLoad(null);
                this.transactedCommerceValueGraphSection.completeLoad(null);
            }
        });
    }

    public getTransactedValueTableData() {
        this.transactedValueUntilTodaySection.startLoader();
        this.transactedValueByWorkingDaySection.startLoader();
        this.transactedValueTotalSection.startLoader();

        this.financialDashboardService.getTransactedValueData(this.selectedMonth, this.selectedYear).subscribe({
            next: (res: ApiResponseModel<GetFinancialDashboardTotalResponseModel[]>) => {
                this.getFinancialDashboardTotalResponseData = res.result.reverse();

                this.filterDataTotalGraph(res.result);
                this.transactedValueUntilTodaySection.completeLoad(this.transactedValueUntilTodayData);
                this.transactedValueByWorkingDaySection.completeLoad(this.transactedValueByWorkingDayData);
                this.transactedValueTotalSection.completeLoad(this.transactedValueTotalData);
            },
            error: () => {
                this.transactedValueUntilTodaySection.completeLoad(null);
                this.transactedValueByWorkingDaySection.completeLoad(null);
                this.transactedValueTotalSection.completeLoad(null);
            }
        });
    }

    public getTransactedValueByDayData() {
        this.transactedValueByDaySection.startLoader();


        this.financialDashboardService.getTransactedValueByDayData(this.selectedMonth, this.selectedYear).subscribe({
            next: (res: ApiResponseModel<GetFinancialDashboardByDayResponseModel[]>) => {
                this.getFinancialDashboardByDayResponseData = res.result.reverse();

                this.filterDataByDaySection(res.result);

                this.transactedValueByDaySection.completeLoad(this.transactedValueByDay);
            },
            error: () => {
                this.transactedValueByDaySection.completeLoad(null);
            }
        });
    }

    filterDataByDaySection(data: GetFinancialDashboardByDayResponseModel[]) {
        this.transactedValueByDay  = {
            graphData: { labels: [], data: [[], []], isEmpty: data.length === 0 },
        };

        data.forEach((item) => {
            const filteredMonths = item.dayDataPerPlan.filter(month => this.selectedPlans.includes(month.plan));

            const transactedValueFromBillable = filteredMonths.reduce((acc, curr) => acc + curr.transactedValueFromBillable, 0);
            const transactedValueFromNonBillable = filteredMonths.reduce((acc, curr) => acc + curr.transactedValueFromNonBillable, 0);

            const monthYearFormatted = `${String(item.day).padStart(2, '0')}/${String(item.month).padStart(2, '0')}/${String(item.year).slice(-2)}`;

            this.transactedValueByDay.graphData.labels.push(monthYearFormatted);
            this.transactedValueByDay.graphData.data[0].push(transactedValueFromBillable);
            this.transactedValueByDay.graphData.data[1].push(transactedValueFromNonBillable);
        });
    }

    filterDataCashbackGraph(data: GetFinancialDashboardCashbackResponseModel[]) {
        let actualMonthData: FinancialDashboardTotalMonthData = createDefaultFinancialDashboardActualMonth(this.selectedMonth, this.selectedYear);
        let actualMonthHasData = false;
        const months: FinancialDashboardTotalMonthData[] = [];

        this.transactedCashbackValueData  = {
            graphData: { labels: [], data: [[], [], []], isEmpty: data.length === 0 },
            tableData: []
        };

        data.forEach((item) => {
            const filteredMonths = item.monthDataPerPlan.filter(month => this.selectedPlans.includes(month.plan) && (this.selectCashbackCustom && month.isCustom || this.selectCashbackRebate && !month.isCustom));

            const orderQuantity = filteredMonths.reduce((acc, curr) => acc + curr.orderQuantity, 0);

            const cashbackValueRepairer = filteredMonths.reduce((acc, curr) => acc + curr.cashbackRepairer, 0);
            const cashbackValueSupplier = filteredMonths.reduce((acc, curr) => acc + curr.cashbackSupplier, 0);
            const cashbackValuePartsfy = filteredMonths.reduce((acc, curr) => acc + curr.cashbackPartsfy, 0);

            const isActualMonth = item.month === this.selectedMonth && item.year === this.selectedYear;
            const isLastYearMonth = item.month === this.selectedMonth && item.year === this.selectedYear - 1;

            const monthYearFormatted = formatDateToMonthTextAndYear(new Date(item.year, item.month - 1, 1));

            this.transactedCashbackValueData.graphData.labels.push(monthYearFormatted);
            this.transactedCashbackValueData.graphData.data[0].push(cashbackValueRepairer);
            this.transactedCashbackValueData.graphData.data[1].push(cashbackValueSupplier);
            this.transactedCashbackValueData.graphData.data[2].push(cashbackValuePartsfy);

            const monthTotal = {
                month: item.month,
                year: item.year,
                orderQuantity,
                isBestMonth: item.isBestMonth,
                isActualMonth,
                isLastYearMonth
            } as FinancialDashboardTotalMonthData;

            if (isActualMonth) {
                actualMonthData = monthTotal;
                actualMonthHasData = true;
            }

            months.push(monthTotal);
        });

        if (!actualMonthHasData) {
            months.splice(months.length - 1, 0, actualMonthData);
        }

        this.transactedCashbackValueData.tableData[0] = this.buildTableData(actualMonthData, months, 'orderQuantity', false, 'order-quantity', true);
    }

    filterDataCommerceGraph(data: GetFinancialDashboardCommerceResponseModel[]) {
        let actualMonthData: FinancialDashboardTotalMonthData = createDefaultFinancialDashboardActualMonth(this.selectedMonth, this.selectedYear);
        let actualMonthHasData = false;

        const months: FinancialDashboardTotalMonthData[] = [];

        this.transactedCommerceValueData  = {
            graphData: { labels: [], data: [[]], isEmpty: data.length === 0 },
            tableData: []
        };

        data.forEach((item) => {
            const filteredMonths = item.monthDataPerPlan.filter(month => this.selectedPlans.includes(month.plan));

            const transactedValueTotal = filteredMonths.reduce((acc, curr) => acc + curr.transactedValue, 0);
            const cashbackValueRepairer = filteredMonths.reduce((acc, curr) => acc + curr.cashbackValueRepairer, 0);
            const cashbackValuePartsfy = filteredMonths.reduce((acc, curr) => acc + curr.cashbackValuePartsfy, 0);
            const commissionValue = filteredMonths.reduce((acc, curr) => acc + curr.commissionValue, 0);

            const isActualMonth = item.month === this.selectedMonth && item.year === this.selectedYear;
            const isLastYearMonth = item.month === this.selectedMonth && item.year === this.selectedYear - 1;

            const monthTotal = {
                month: item.month,
                year: item.year,
                transactedValueTotal,
                cashbackValuePartsfy,
                cashbackValueRepairer,
                commissionValue,
                isBestMonth: item.isBestMonth,
                isActualMonth,
                isLastYearMonth
            } as FinancialDashboardTotalMonthData;

            if (isActualMonth) {
                actualMonthData = monthTotal;
                actualMonthHasData = true;
            }

            months.push(monthTotal);

            const monthYearFormatted = formatDateToMonthTextAndYear(new Date(item.year, item.month - 1, 1));

            if (item.isBestMonth)
                return;

            this.transactedCommerceValueData.graphData.labels.push(monthYearFormatted);
            this.transactedCommerceValueData.graphData.data[0].push(transactedValueTotal);
        });

        if (!actualMonthHasData) {
            months.splice(months.length - 1, 0, actualMonthData);

            const monthYearFormatted = formatDateToMonthTextAndYear(new Date(actualMonthData.year, actualMonthData.month - 1, 1));
            this.transactedCommerceValueData.graphData.labels.push(monthYearFormatted);
            this.transactedCommerceValueData.graphData.data[0].push(actualMonthData.transactedValueTotal);
        }

        this.transactedCommerceValueData.tableData[0] = this.buildTableData(actualMonthData, months, 'transactedValueTotal', true, 'transacted-total');
        this.transactedCommerceValueData.tableData[1] = this.buildTableData(actualMonthData, months, 'cashbackValueRepairer', true, 'cashback-repairer');
        this.transactedCommerceValueData.tableData[2] = this.buildTableData(actualMonthData, months, 'cashbackValuePartsfy', true, 'cashback-partsfy');
        this.transactedCommerceValueData.tableData[3] = this.buildTableData(actualMonthData, months, 'commissionValue', true, 'commission-total');
    }

    filterDataTotalGraph(data: GetFinancialDashboardTotalResponseModel[]) {
        let actualMonthData: FinancialDashboardTotalMonthData;
        const months: FinancialDashboardTotalMonthData[] = [];

        this.transactedValueUntilTodayData  = {
            graphData: { labels: [], data: [[], []], isEmpty: data.length === 0 },
            tableData: []
        };

        this.transactedValueByWorkingDayData  = {
            graphData: { labels: [], data: [[], []], isEmpty: data.length === 0 },
            tableData: []
        };

        this.transactedValueTotalData  = {
            graphData: { labels: [], data: [[], []], isEmpty: data.length === 0 },
            tableData: []
        };

        data.forEach((item) => {
            const filteredMonths = item.monthDataPerPlan.filter(month => this.selectedPlans.includes(month.plan));

            const transactedValueFromBillable = filteredMonths.reduce((acc, curr) => acc + curr.transactedValueFromBillable, 0);
            const transactedValueFromBillableUntilToday = filteredMonths.reduce((acc, curr) => acc + curr.transactedValueFromBillableUntilSelectedDate, 0);
            const transactedValueFromBillableByWorkingDay = this.handleDivisionTreatingZeroDivisionError(transactedValueFromBillableUntilToday, item.totalWorkingDaysUntilSelectedDate);

            const transactedValueFromNonBillable = filteredMonths.reduce((acc, curr) => acc + curr.transactedValueFromNonBillable, 0);
            const transactedValueFromNonBillableUntilToday = filteredMonths.reduce((acc, curr) => acc + curr.transactedValueFromNonBillableUntilSelectedDate, 0);
            const transactedValueFromNonBillableByWorkingDay = this.handleDivisionTreatingZeroDivisionError(transactedValueFromNonBillableUntilToday, item.totalWorkingDaysUntilSelectedDate);

            const transactedValueTotal = filteredMonths.reduce((acc, curr) => acc + curr.transactedValue, 0);
            const transactedValueTotalUntilToday = filteredMonths.reduce((acc, curr) => acc + curr.transactedValueUntilSelectedDate, 0);
            const transactedValueTotalByWorkingDay = this.handleDivisionTreatingZeroDivisionError(transactedValueTotalUntilToday, item.totalWorkingDaysUntilSelectedDate);

            const orderQuantity = filteredMonths.reduce((acc, curr) => acc + curr.orderQuantity, 0);
            const orderQuantityUntilToday = filteredMonths.reduce((acc, curr) => acc + curr.orderQuantityUntilSelectedDate, 0);
            const orderQuantityByWorkingDay = Math.round(this.handleDivisionTreatingZeroDivisionError(orderQuantityUntilToday, item.totalWorkingDaysUntilSelectedDate));

            const isActualMonth = item.month === this.selectedMonth && item.year === this.selectedYear;
            const isLastYearMonth = item.month === this.selectedMonth && item.year === this.selectedYear - 1;

            const monthTotal = {
                month: item.month,
                year: item.year,
                orderQuantity,
                orderQuantityUntilToday,
                orderQuantityByWorkingDay,
                transactedValueFromBillable,
                transactedValueFromBillableUntilToday,
                transactedValueFromBillableByWorkingDay,
                transactedValueTotal,
                transactedValueTotalUntilToday,
                transactedValueTotalByWorkingDay,
                totalWorkingDays: item.totalWorkingDays,
                totalWorkingDaysUntilSelectedDate: item.totalWorkingDaysUntilSelectedDate,
                isBestMonth: item.isBestMonth,
                isActualMonth,
                isLastYearMonth
            };

            const monthYearFormatted = formatDateToMonthTextAndYear(new Date(item.year, item.month - 1, 1));

            this.transactedValueUntilTodayData.graphData.labels.push(monthYearFormatted);
            this.transactedValueUntilTodayData.graphData.data[0].push(transactedValueFromBillableUntilToday);
            this.transactedValueUntilTodayData.graphData.data[1].push(transactedValueFromNonBillableUntilToday);

            this.transactedValueByWorkingDayData.graphData.labels.push(monthYearFormatted);
            this.transactedValueByWorkingDayData.graphData.data[0].push(transactedValueFromBillableByWorkingDay);
            this.transactedValueByWorkingDayData.graphData.data[1].push(transactedValueFromNonBillableByWorkingDay);

            this.transactedValueTotalData.graphData.labels.push(monthYearFormatted);
            this.transactedValueTotalData.graphData.data[0].push(transactedValueFromBillable);
            this.transactedValueTotalData.graphData.data[1].push(transactedValueFromNonBillable);

            if (isActualMonth)
                actualMonthData = monthTotal;

            months.push(monthTotal);
        });

        this.transactedValueUntilTodayData.tableData[0] = this.buildTableData(actualMonthData, months, 'transactedValueTotalUntilToday', true, 'transacted-total');
        this.transactedValueUntilTodayData.tableData[1] = this.buildTableData(actualMonthData, months, 'transactedValueFromBillableUntilToday', true, 'transacted-billable');
        this.transactedValueUntilTodayData.tableData[2] = this.buildTableData(actualMonthData, months, 'orderQuantityUntilToday', false, 'order-quantity');

        this.transactedValueByWorkingDayData.tableData[0] = this.buildTableData(actualMonthData, months, 'transactedValueTotalByWorkingDay', true, 'transacted-total');
        this.transactedValueByWorkingDayData.tableData[1] = this.buildTableData(actualMonthData, months, 'transactedValueFromBillableByWorkingDay', true, 'transacted-billable');
        this.transactedValueByWorkingDayData.tableData[2] = this.buildTableData(actualMonthData, months, 'orderQuantityByWorkingDay', false, 'order-quantity');

        this.transactedValueTotalData.tableData[0] = this.buildTableData(actualMonthData, months, 'transactedValueTotal', true, 'transacted-total', true, 'totalWorkingDays');
        this.transactedValueTotalData.tableData[1] = this.buildTableData(actualMonthData, months, 'transactedValueFromBillable', true, 'transacted-billable', true, 'totalWorkingDays');
        this.transactedValueTotalData.tableData[2] = this.buildTableData(actualMonthData, months, 'orderQuantity', false, 'order-quantity', true, 'totalWorkingDays');
    }

    handleDivisionTreatingZeroDivisionError(value: number, divisor: number) {
        if (divisor === 0)
            return 0;

        return value / divisor;
    }

    startAllLoaders() {
        this.transactedCashbackValueSection.startLoader();
        this.transactedCommerceValueSection.startLoader();
        this.transactedCommerceValueGraphSection.startLoader();
        this.transactedValueUntilTodaySection.startLoader();
        this.transactedValueByWorkingDaySection.startLoader();
        this.transactedValueTotalSection.startLoader();
        this.transactedValueByDaySection.startLoader();
    }

    stopAllLoaders() {
        this.transactedCashbackValueSection.completeLoad(this.transactedCashbackValueData);
        this.transactedCommerceValueSection.completeLoad(this.transactedCommerceValueData);
        this.transactedCommerceValueGraphSection.completeLoad(this.transactedCommerceValueData);
        this.transactedValueUntilTodaySection.completeLoad(this.transactedValueUntilTodayData);
        this.transactedValueByWorkingDaySection.completeLoad(this.transactedValueByWorkingDayData);
        this.transactedValueTotalSection.completeLoad(this.transactedValueTotalData);
        this.transactedValueByDaySection.completeLoad(this.transactedValueByDay);
    }

    get selectedCashbackFilter() {
        return this._selectedCashbackFilter;
    }

    selectCashbackFilter(cashbackSelectedString: string) {
        this._selectedCashbackFilter = cashbackSelectedString;
        var cashbackSelected = parseInt(cashbackSelectedString);

        this.selectCashbackCustom = cashbackSelected === 0 || cashbackSelected === 1;
        this.selectCashbackRebate = cashbackSelected === 0 || cashbackSelected === 2;

        this.transactedCashbackValueSection.startLoader();
        this.filterDataCashbackGraph(this.getFinancialDashboardCashbackResponseData);
        this.transactedCashbackValueSection.completeLoad(this.transactedCashbackValueData);
    }

    get selectedMonthFilter() {
        return this._selectedMonthIndexFilter;
    }

    set selectedMonthFilter(monthIndexString: string) {
        this._selectedMonthIndexFilter = monthIndexString;

        this.updateSelectedMonthAndYear();
        this.getTransactedValueTableData();
        this.getTransactedValueByDayData();
        this.getTransactedCommerceValueTableData();
        this.getTransactedCashbackValueTableData();
    }

    get selectedPlanFilter() {
        return this._selectedPlanFilter;
    }

    set selectedPlanFilter(planString: string) {
        this._selectedPlanFilter = planString;
        var plan = parseInt(planString);

        if (plan === 0) {
            this.selectedPlans = [PlanEnum.Popular, PlanEnum.V8, PlanEnum.Turbo];
        } else {
            this.selectedPlans = [plan as PlanEnum];
        }

        this.startAllLoaders();

        this.filterDataByDaySection(this.getFinancialDashboardByDayResponseData);
        this.filterDataCashbackGraph(this.getFinancialDashboardCashbackResponseData);
        this.filterDataCommerceGraph(this.getFinancialDashboardCommerceResponseData);
        this.filterDataTotalGraph(this.getFinancialDashboardTotalResponseData);

        this.stopAllLoaders();
    }

    updateSelectedMonthAndYear() {
        const selectedDate = this.lastMonths[parseInt(this._selectedMonthIndexFilter)];
        this.selectedMonth = selectedDate.getMonth() + 1;
        this.selectedYear = selectedDate.getFullYear();
    }
}
